import { DotLegalPaper, DotLegalSwitch } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation";
import { Box } from "@mui/material";
import useAuditTab from "./AuditTab.hooks";
import { AuditType } from "./AuditTab.types";

export interface IAuditTabProps {
    externalContent: React.ReactNode;
    internalContent: React.ReactNode;
}

function AuditTab(props: IAuditTabProps) {
    const { translateString } = useTranslation();
    const { setSelectedAuditType, selectedAuditType, disableSwitch } = useAuditTab();

    return (
        <DotLegalPaper>
            <Box sx={{ marginBottom: 1 }}>
                <DotLegalSwitch
                    onChange={() => {
                        if (selectedAuditType === AuditType.External) {
                            setSelectedAuditType(AuditType.Internal);
                        } else {
                            setSelectedAuditType(AuditType.External);
                        }
                    }}
                    disabled={disableSwitch}
                    checked={selectedAuditType === AuditType.Internal}
                    leftLabel={translateString("external")}
                    rightLabel={translateString("internal")}
                />
            </Box>
            {selectedAuditType === AuditType.Internal ? props.internalContent : props.externalContent}
        </DotLegalPaper>
    );
}

export default AuditTab;
